import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AuthService } from './core/services/auth.service';
import { InstalarAppService } from './core/services/instalar-app.service';
import { PushNotificacionesService } from './core/services/push-notificaciones.service';
import { MayorapPreset } from './core/utils/mayorap-preset';
import { PRIMENG_ES } from './core/utils/primeng-es';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, loadingInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MayorapPreset,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
      translation: PRIMENG_ES,
    }),
    MessageService,
    ConfirmationService,
    provideAppInitializer(() => inject(AuthService).refreshOnStartup()),
    provideAppInitializer(() => {
      inject(InstalarAppService);
      inject(PushNotificacionesService).registrarServiceWorker();
    }),
  ],
};
